import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';

import { environment } from '#environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authStorage = inject(OAuthStorage);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const authToken = this.authStorage.getItem('access_token');
    if (req.url?.endsWith('oidc/oauth2/token') || !authToken) {
      return next.handle(req);
    }
    const authReq = req.clone({
      body: req.body,
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
        ...(req.url.startsWith(environment.customerVettingUrl) && { tracestate: 'EHKYC=EHKYC' }),
      },
    });
    return next.handle(authReq);
  }
}
